"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicVehicleFeatureCategoryDTO = exports.VehicleFeatureCategoryUpdateDTO = exports.VehicleFeatureCategoryCreateDTO = exports.VehicleFeatureCategoryGetUniqueDTO = exports.VehicleFeatureCategoryGetDTO = void 0;
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const BaseDTO_1 = require("./BaseDTO");
class VehicleFeatureCategoryGetDTO {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map(error => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(VehicleFeatureCategoryGetDTO, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
exports.VehicleFeatureCategoryGetDTO = VehicleFeatureCategoryGetDTO;
// Use this to get a unique vehicle make by unique fields
class VehicleFeatureCategoryGetUniqueDTO {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map(error => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(VehicleFeatureCategoryGetUniqueDTO, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
exports.VehicleFeatureCategoryGetUniqueDTO = VehicleFeatureCategoryGetUniqueDTO;
class VehicleFeatureCategoryCreateDTO extends BaseDTO_1.BaseCreateDTO {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map(error => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(VehicleFeatureCategoryCreateDTO, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.Matches)(/^[a-zA-Z0-9\s\-\_]*$/, {
        message: 'Name can only contain letters, numbers, spaces, hyphens, and underscores.',
    }),
    __metadata("design:type", String)
], VehicleFeatureCategoryCreateDTO.prototype, "name", void 0);
exports.VehicleFeatureCategoryCreateDTO = VehicleFeatureCategoryCreateDTO;
class VehicleFeatureCategoryUpdateDTO extends BaseDTO_1.BaseUpdateDTO {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map(error => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(VehicleFeatureCategoryUpdateDTO, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.Matches)(/^[a-zA-Z0-9\s\-\_]*$/, {
        message: 'Name can only contain letters, numbers, spaces, hyphens, and underscores.',
    }),
    __metadata("design:type", String)
], VehicleFeatureCategoryUpdateDTO.prototype, "name", void 0);
exports.VehicleFeatureCategoryUpdateDTO = VehicleFeatureCategoryUpdateDTO;
class DynamicVehicleFeatureCategoryDTO {
    constructor(payload) {
        this.existingId = payload.existingId;
        this.new = payload.new;
    }
    validate() {
        if (!this.existingId && !this.new) {
            throw new Error('Either existingId or new details must be provided.');
        }
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(DynamicVehicleFeatureCategoryDTO, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], DynamicVehicleFeatureCategoryDTO.prototype, "existingId", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => VehicleFeatureCategoryCreateDTO),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", VehicleFeatureCategoryCreateDTO)
], DynamicVehicleFeatureCategoryDTO.prototype, "new", void 0);
exports.DynamicVehicleFeatureCategoryDTO = DynamicVehicleFeatureCategoryDTO;
